<section id="location" class="address-section">
  <div class="container">
    <div class="section-head text-center">
      <h2>Visit Us</h2>
      <p>Conveniently located across from the Center MARTA station in Arts Center Tower, Atlanta</p>
    </div>

    <div class="row address-grid">
      <div class="col-md-6 col-sm-12">
        <div class="info-card">
          <div class="info-row">
            <div class="icon-wrap"><mat-icon>place</mat-icon></div>
            <div class="info-text">
              <h3>Location</h3>
              <p>Arts Center Tower, 1270 W Peachtree</p>
              <p>St NW, Suite 2, Atlanta, GA 30309</p>
              
            </div>
          </div>

           <div class="info-row">
            <div class="icon-wrap"><mat-icon>schedule</mat-icon></div>
            <div class="info-text">
              <h3>Hours</h3>
              <p>Monday - Friday: 7:30 AM - 6:30 PM</p>
              <p>Saturday: 9:00 AM - 5:00 PM</p>
              <p>Sunday: 12:30 PM - 5:30 PM</p>
            </div>
          </div>



          <div class="info-row">
            <div class="icon-wrap"><mat-icon>near_me</mat-icon></div>
            <div class="info-text">
              <h3>Website</h3>
              <p>www.dryocleaners.com</p>
            </div>
          </div>

          <div class="info-row">
            <div class="icon-wrap"><mat-icon>phone</mat-icon></div>
            <div class="info-text">
              <h3>Phone</h3>
              <p>404 944 6670</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-sm-12">
        <div class="map-card">
          
          <iframe
            title="dryo location map"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            src="https://maps.google.com/maps?q=Arts%20Center%20Tower%2C%201270%20W%20Peachtree%20St%20NW%2C%20Suite%202%2C%20Atlanta%2C%20GA%2030309&z=16&output=embed">
          </iframe>
          <div class="map-label">
            <h3>arts center tower, 1270 w peachtree</h3>
            <p>st nw, suite 2, atlanta, ga 30309</p>
          </div>
         

          <!-- <div class="map-static-card">
            <mat-icon class="map-static-icon">place</mat-icon>
            <h3>Arts Center MARTA</h3>
            <p>Midtown Atlanta, GA</p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</section>
